import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Gear, ShieldCheck, SignOut } from "@phosphor-icons/react";
import { useAuth } from "@/contexts/AuthContext";
import Logo from "@/components/Logo";

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const onLogout = async () => {
    await logout();
    nav("/");
  };
  const isAdmin = user?.role === "admin";
  return (
    <div className="min-h-screen bg-[--paper]">
      <header className="border-b border-[--line] bg-white sticky top-0 z-30">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/dashboard" data-testid="brand-link" className="flex items-center gap-3">
            <Logo className="h-8" />
            <span className="overline text-[--muted] hidden sm:inline ml-3">STUDIO</span>
          </Link>
          <div className="flex items-center gap-4">
            {user && (
              <div className="hidden md:flex items-center gap-3">
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="w-8 h-8 object-cover hard-border" />
                ) : (
                  <div className="w-8 h-8 bg-[--accent] text-white grid place-items-center font-mono text-xs">
                    {(user.name || user.email || "?").charAt(0).toUpperCase()}
                  </div>
                )}
                <div className="leading-tight">
                  <div className="text-sm font-semibold flex items-center gap-2" data-testid="user-name">
                    {user.name}
                    {isAdmin && (
                      <span className="text-[10px] font-mono px-1.5 py-0.5 bg-[--ink] text-white" data-testid="admin-badge">ADMIN</span>
                    )}
                  </div>
                  <div className="text-[11px] text-[--muted] font-mono">{user.email}</div>
                </div>
              </div>
            )}
            {isAdmin && (
              <Link
                to="/admin"
                data-testid="admin-link"
                className="border border-[--ink] px-3 py-2 text-xs font-semibold hover:bg-[--ink] hover:text-white transition-colors inline-flex items-center gap-2"
                title="Admin"
              >
                <ShieldCheck weight="bold" size={14} /> <span className="hidden sm:inline">Admin</span>
              </Link>
            )}
            {isAdmin && (
              <Link
                to="/settings"
                data-testid="settings-link"
                className="border border-[--ink] px-3 py-2 text-xs font-semibold hover:bg-[--ink] hover:text-white transition-colors inline-flex items-center gap-2"
                title="Settings"
              >
                <Gear weight="bold" size={14} /> <span className="hidden sm:inline">Settings</span>
              </Link>
            )}
            <button
              onClick={onLogout}
              data-testid="logout-btn"
              className="border border-[--ink] px-3 py-2 text-xs font-semibold hover:bg-[--ink] hover:text-white transition-colors inline-flex items-center gap-2"
            >
              <SignOut weight="bold" size={14} /> Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">{children}</main>
    </div>
  );
}
